import _ from 'lodash';
import { createSelector } from 'reselect';

const usersKey="configState";

export const getConfigState = (state) => _.get(state, usersKey);
export const getTheme = createSelector(getConfigState, (state) => _.get(state, 'selectedTheme'));


